module.exports = __webpack_public_path__ + "img/inactive.7721cba.svg";